import { useContext, useState } from "react";
import Accordion from "../../shared/accordion/Accordion";
import CompHeader from "./CompHeader";
import NewsCard from "./NewsCard";
import { screenSizeContext } from "@/app/store/context/screenSizesContext";

const WhatsHappening = ({ data, insideAmenitiesDetailsPage, sameAmenitiesDetailsPage, optimizedImage }: any) => {
    const [activeAccordion, setActiveAccordion] = useState(data?.length - 1);
    const { isIpad } = useContext(screenSizeContext)
    return (
        <div className="overflow-hidden">
            <div className="header flex justify-between items-center px">
                <CompHeader />
            </div>
            <div>
                {!insideAmenitiesDetailsPage && data?.map((item: any, index: number) => (
                    index < 3 &&
                    item?.card_title?.en &&
                    <Accordion
                        height={isIpad ? "12rem" : "8rem"} key={index} activeAccordion={activeAccordion} setActiveAccordion={setActiveAccordion} index={index} action={() => { }}>
                        <NewsCard
                            key={index}
                            index={index}
                            activeAccordion={activeAccordion}
                            data={{ ...item, bg: index == 0 ? "bg-oBlue-40" : index == 1 ? "bg-oBlue-60" : "bg-oBlue-100" }}
                            insideAmenitiesDetailsPage={sameAmenitiesDetailsPage}
                            optimizedImage={optimizedImage}
                        />
                    </Accordion>
                ))}

                {insideAmenitiesDetailsPage && data?.map((item: any, index: number) => (
                    index < 5 &&
                    item?.card_title?.en &&
                    <Accordion
                        height={isIpad ? "12rem" : "8rem"} key={index} activeAccordion={activeAccordion} setActiveAccordion={setActiveAccordion} index={index} action={() => { }}>
                        <NewsCard
                            key={index}
                            index={index}
                            activeAccordion={activeAccordion}
                            data={{ ...item, bg: index == 0 ? "bg-oBlue-40" : index == 1 ? "bg-oBlue-60" : index == 2 ? "bg-oBlue-70" : index == 3 ? "bg-oBlue-90" : "bg-oBlue-100" }}
                            insideAmenitiesDetailsPage
                        />
                    </Accordion>
                ))}
            </div>
        </div>
    );
}

export default WhatsHappening;